import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=b010725c&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=b010725c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b010725c",
  null
  
)

export default component.exports